import React, { useState } from 'react'
import { LeftSide, RightSide, SectionName, SubHeaderContainer, ButtonCreate, RefreshIcon, RefreshIconContainer, OptionsButton } from '../../../components/styles/subheader-style'
import { Content } from './style'
import { Outlet, useNavigate, useOutletContext } from 'react-router-dom'
import { TypeMainOutlet } from '..'
import filterIcon from '../../../assets/stock/TableMovementHeader/filter.svg'
import refresh_act from '../../../assets/refresh-active.svg'

interface ServicesSubHeaderProps {
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>
  isLoading?: boolean
}

const ServicesSubHeader:React.FC<ServicesSubHeaderProps> = ({ setRefresh, isLoading }) => {
  const navigate = useNavigate()
  
  const handleCreateClick = () => {
    navigate('create')
  }
  
  return (
    <SubHeaderContainer>
    <LeftSide>
      <SectionName>Serviços</SectionName>
    </LeftSide>
    <RightSide>
      <RefreshIconContainer onClick={() => setRefresh(prev => !prev)} title="Atualizar">
        <RefreshIcon src={refresh_act} alt="Atualizar" $spinning={isLoading} />
      </RefreshIconContainer>
      <OptionsButton>
        <img src={filterIcon} alt='Filtrar' />
      </OptionsButton>
      <ButtonCreate onClick={handleCreateClick}>
        + Novo serviço
      </ButtonCreate>
    </RightSide>
  </SubHeaderContainer>
  )
}

const ServicesContent = () => {  
  const { search } = useOutletContext<TypeMainOutlet>()
  const [refresh, setRefresh] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const outletContext = { refresh, setIsLoading, isLoading }
  return (
    <>
    <ServicesSubHeader setRefresh={setRefresh} isLoading={isLoading} />
    <Content>
      <Outlet context={{ search, outletContext }}/>
    </Content>
    </>
  )
}

export default ServicesContent